<template>
  <div class="userInfoZh">
    <div class="explain"></div>
    <el-form
      label-width="120px"
      :model="userInfoForm"
      ref="userInfoForm"
      :rules="userInfoRule"
      :disabled="generationBinding"
      :hide-required-asterisk="true"
    >
      <div>
        <div class="item clearfix">
          <span class="key">头像：</span>
          <span class="value">
            <p v-if="isExamine">
              <span>{{ USER_INFO_DATA.name_zh | textFormat }}</span>
            </p>
            <div class="name_input" v-else>
              <el-form-item prop="name_zh">
                <div class="imgDiv">
                  <div class="markImg tc" v-if="!generationBinding">
                    <fileUpload
                      @uploadCompleteOSS="uploadimg"
                      :needCropImg="fileUploadOptions.needCropImg"
                      :aspectRatio="fileUploadOptions.aspectRatio"
                      :accept="fileUploadOptions.accept"
                    >
                      <span>更换头像</span>
                    </fileUpload>
                  </div>
                  <el-image
                    class="avatar"
                    :src="
                      userInfoForm.avatar
                        ? userInfoForm.avatar
                        : DEFAULT_AVATARSQUARE
                    "
                  ></el-image>
                </div>
              </el-form-item>
            </div>
          </span>
        </div>
        <div class="flex">
          <div class="item clearfix">
            <span class="key">姓名：</span>
            <span class="value">
              <p v-if="isExamine">
                <span>{{ USER_INFO_DATA.name_zh | textFormat }}</span>
              </p>
              <div class="name_input" v-else>
                <el-form-item prop="name_zh">
                  <el-input
                    v-model="userInfoForm.name_zh"
                    size="small"
                    class="input"
                  ></el-input>
                </el-form-item>
              </div>
            </span>
          </div>
          <div class="item clearfix">
            <span class="key">手机号：</span>
            <span class="value">
              <p v-if="isExamine">
                {{ userInfoForm.mobile | phoneFormat(userInfoForm.area_code) }}
              </p>
              <el-form-item :title="$t('notChangePhoneTip')" v-else>
                <el-input
                  :value="userInfoForm.mobile | phoneFormat(userInfoForm.area_code)"
                  size="small"
                  class="input"
                  disabled
                ></el-input>
              </el-form-item>
            </span>
          </div>
        </div>
        <div class="flex">
          <div class="item clearfix">
            <span class="key">邮箱：</span>
            <span class="value">
              <p v-if="isExamine">{{ USER_INFO_DATA.email | textFormat }}</p>
              <el-form-item prop="email" :title="$t('notChangeEmailTip')" v-else>
                <el-input
                  v-model="userInfoForm.email"
                  size="small"
                  class="input"
                  :disabled="PJID !== 'YMP'"
                ></el-input>
              </el-form-item>
            </span>
          </div>
          <div class="item">
            <span class="key">微信：</span>
            <span class="value">
              <p v-if="isExamine">{{ USER_INFO_DATA.wechat | textFormat }}</p>
              <el-form-item v-else>
                <el-input
                  v-model="userInfoForm.wechat"
                  size="small"
                  class="input"
                ></el-input>
              </el-form-item>
            </span>
          </div>
        </div>
        <div class="flex">
          <div class="item">
            <span class="key">QQ：</span>
            <span class="value">
              <p v-if="isExamine">{{ USER_INFO_DATA.qq | textFormat }}</p>
              <el-form-item v-else>
                <el-input
                  v-model="userInfoForm.qq"
                  :disabled="true"
                  size="small"
                  class="input"
                ></el-input>
              </el-form-item>
            </span>
          </div>
          <div class="item">
            <span class="key">电话：</span>
            <span class="value">
              <p v-if="isExamine">{{ USER_INFO_DATA.telephone | textFormat }}</p>
              <el-form-item v-else prop="telephone">
                <el-input
                  v-model="userInfoForm.telephone"
                  size="small"
                  class="input"
                ></el-input>
              </el-form-item>
            </span>
          </div>
          
        </div>
        <div class="flex">
          <div class="item">
            <span class="key">所属公司：</span>
            <span class="value">
              <el-form-item>
                <el-input
                  v-model="userInfoForm.company_name_zh"
                  :disabled="true"
                  size="small"
                  class="input"
                ></el-input>
              </el-form-item>
            </span>
            <el-button v-if="!generationBinding" class="bindbtn" type="primary" plain size="small" @click="bindCompany">绑定公司</el-button>
          </div>
        </div>
        <div class="flex" v-if="PJID === 'YMP' && USER_INFO_DATA.user_type==1 && !generationBinding">
          <div class="item"  style="margin-bottom:30px">
            <span class="key">销售：</span>
            <span class="value">
              <el-select
                size="small"
                v-model="userInfoForm.bind_sales"
                :disabled="bind_sales_disabled ? true:false"
                filterable
                placeholder="请选择销售"
                style="width:300px"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.name_zh || item.name_en"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </span>
          </div>
          <div class="item">
            <span class="key">合作销售手机：</span>
            <span class="value">
              <el-select
                size="small"
                v-model="userInfoForm.bind_sales"
                filterable
                :disabled="true"
                placeholder="请先选择销售"
                style="width:300px"
              >
                <el-option
                  v-for="(item, index) in options"
                  :key="index"
                  :label="item.mobile"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </span>
          </div>
          <p></p>
        </div>
      </div>
      <div class="footer-btn">
        <el-button
          v-if="!generationBinding"
          type="primary"
          size="small"
          style="padding: 9px 25px"
          :loading="saveLoading"
          @click="confirm"
          >更新资料</el-button
        >
      </div>
    </el-form>


    <el-dialog title="绑定企业" :visible.sync="dialogShow" width="1200px">
      <yetJoin :generationBinding="true" :title="'正在关联企业信息'" :bind_user_id="userInfoForm.id" @changeCompany="companyStats"></yetJoin>
    </el-dialog>
  </div>
</template>

<script>
import { sexList } from "~/baseUtils/enumValue";
import fileUpload from "~/baseComponents/fileUpload";
import yetJoin from "~bac/components/company/basic/yetJoin";
export default {
  components: { fileUpload ,yetJoin},
  props: {
    generationBinding: {
      type: Boolean,
      default: false
    },
    bind_user_id: {
      type: String | Number,
      default: ''
    },
  },
  data() {
    return {
      from_source: "",
      dialogShow: false,
      userInfoForm: {},
      isExamine: false,
      bind_sales_disabled: false,
      sexList,
      saveLoading: false,
      fileUploadOptions: {
        needCropImg: true,
        aspectRatio: 20 / 20,
        accept: ".jpg,.jpeg,.bmp,.png",
      },
      avatarImg:
        "https://attached-file.oss-cn-shanghai.aliyuncs.com/websiteImg/images/default-logo.jpg",
      userInfoRule: {
        name_zh: [
          {
            required: true,
            message: " ",
            trigger: "blur",
          },
        ],
        telephone:[
          { required: false, message: " ", trigger: "blur" },
          { validator: this.isTelOrFax, trigger: "blur" }
        ],
        email:[
          { required: false, message: " ", trigger: "blur" },
          { validator: this.isEmail, trigger: "blur" }
        ]
      },
      USER_INFO_DATA:'',
      options: null,
    };
  },
  watch: {
    USER_INFO_DATA: {
      deep: true,
      handler(nv) {
        this.initFormData();
      },
    },
  },
  methods: {
    companyStats() {
      this.getUserInfo()
      this.dialogShow = false;
    },
    bindCompany(){
      this.dialogShow = true;
    },
    async getUserList() {
      let data = await this.$store.dispatch("baseConsole/get_sales_list",{is_white:1});
      if (data.success) {
        this.options = data.data;
        this.saleId = this.value;
      }
    },
    isTelOrFax (rule, value, callback) {
      if (!value) {
          callback();
        } else {
        const reg = /^(\d{3,4}-)?\d{5,8}$/;
        const isTel = reg.test(value);
        if (!isTel ) {
          callback(new Error("座机格式如: 021-1234567"));
        } else {
          callback();
        }
      }
    },
    isEmail (rule, value, callback) {
      if (!value) {
          callback();
        } else {
          const reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
          const email = reg.test(value);
        if (!email) {
          callback(new Error("邮箱格式如: admin@163.com"));
        } else {
          callback();
        }
      }
    },
    initFormData() {
      let params = Object.assign({}, this.USER_INFO_DATA);
      params.mobile = params.mobile && params.mobile != "null" ? params.mobile : "";
      params.email = params.email && params.email != "null" ? params.email : "";
      params.telephone = params.telephone && params.telephone != "null" ? params.telephone : "";
      params.birthday = params.birthday
        ? this.$moment(params.birthday * 1000).format("YYYY-MM-DD")
        : "";
      params.sex = params.sex ? params.sex : 1;
      this.userInfoForm = params;
    },
    uploadimg(result) {
      this.userInfoForm.avatar = result.url;
    },
    async confirm() {
      this.$log({
        type: 1,
        topic: "ymp.workbench",
        id: "ymp.workbench.info.save",
        content: JSON.stringify({
          id: this.USER_INFO_DATA.id || ''
        }),
      });
      this.saveLoading = true;
      try {
        let params = Object.assign({}, this.userInfoForm);
        params.user_id = this.USER_INFO_DATA.id;
        if (params.birthday) {
          params.birthday = this.$moment(params.birthday).unix();
        }
        let apiInterface = this.generationBinding ? 'baseConsole/user_saveOtherUserInfo' : "baseConsole/user_saveUserInfo"
        let result = await this.$store.dispatch(
          apiInterface,
          params
        );
        if (result.success) {
          if (this.userInfoForm.birthday) {
            this.$moment(this.userInfoForm.birthday * 1000).format(
              "YYYY-MM-DD"
            );
          } else {
            this.userInfoForm.birthday = "";
          }
          this.getUserInfo(false,null);
          this.$ssTip();
          if (this.from_source != "") {
            this.$router.push({ path: this.from_source });
          }
        }
      } catch (e) {
        console.log(e);
      }
      this.saveLoading = false;
    },
    async getUserInfo(isAgent,currentID){
      let params = {};
      if(isAgent){
        params.user_id = currentID
      }else{
        params.user_id = this.generationBinding?this.bind_user_id: this.USER_INFO.id;
      }
      let apiInterface = this.generationBinding ? 'baseConsole/user_getOtherUserInfo' : "baseConsole/user_getUserInfo"
      let result = await this.$store.dispatch(
        apiInterface,
        params
      );
      if (result.success) {
        this.$nextTick(()=>{
          this.USER_INFO_DATA = result.data;
          if (JSON.stringify(this.USER_INFO_DATA) != {}) {
            // this.avatarImg = this.USER_INFO_DATA.avatar;
            this.userInfoForm = {
              name_zh: this.USER_INFO_DATA.name_zh,
              
              sex: this.USER_INFO_DATA.sex,
              job_title_zh: this.USER_INFO_DATA.job_title_zh,
              birthday: this.USER_INFO_DATA.birthday
                ? this.$moment(this.USER_INFO_DATA.birthday * 1000).format("YYYY-MM-DD")
                : "",
              linkedin: this.USER_INFO_DATA.linkedin,
              telephone: this.USER_INFO_DATA.telephone,
              facebook: this.USER_INFO_DATA.facebook,
              skype: this.USER_INFO_DATA.skype,
              wechat: this.USER_INFO_DATA.wechat,
              qq: this.USER_INFO_DATA.qq,
              avatar: this.USER_INFO_DATA.avatar,
              email: this.USER_INFO_DATA.email,
              bind_sales: this.USER_INFO_DATA.bind_sales ? this.USER_INFO_DATA.bind_sales:''
            };
            this.bind_sales_disabled = this.USER_INFO_DATA.bind_sales ? true:false
          }
        })
      }
    }
  },
  mounted() {
    if (this.$route.query.parameter) {
      this.from_source = this._decode(this.$route.query.parameter).source;
    }
    this.getUserList();
    this.getUserInfo(false,null);
  },
};
</script>

<style lang="less" scoped>
.userInfoZh {
  div {
    color: #808080;
    p {
      color: #808080;
    }
    /deep/ .el-form-item{
      margin-bottom: 22px !important;
    }
  }
  .flex{
    display: flex;
    position: relative;
    .item{
      width: 500px;
    }
  }
  .explain {
    padding: 10px 12px;
    line-height: 18px;
    margin-bottom: 10px;
  }
  .key {
    width: 120px;
    float: left;
    color: #808080;
    text-align: right;
    padding-right: 10px;
    line-height: 35px;
  }
  .avatar {
    width: 100%;
  }
  .imgDiv {
    position: relative;
    width: 100px;
    height: 100px;
    .markImg {
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 100;
      line-height: 100px;
      transition: 0.5s;
      span {
        color: #fff;
        display: none;
      }
    }
    &:hover {
      .markImg {
        background-color: rgba(0, 0, 0, 0.5);
        span {
          display: block;
        }
      }
    }
  }
  /deep/.el-select {
    width: 250px;
  }
  .litterTitle {
    margin: 10px 0 20px;
  }
  .input {
    width: 300px;
  }
  .footer-btn {
    padding: 0 0 20px 120px;
  }
  .bindbtn{
    position: absolute;
    top: 4px;
    left: 440px;
  }
}
</style>